import {Box} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import { RecoilRoot } from "recoil";
import PageNotFound from "../../util/page/PageNotFound";
import CustomerBaseList from "./page/CustomerBaseList";
import ViewCustomerBase from "./page/ViewCustomerBase";
import { CBCreationPathName } from "./types";

const CustomerBaseMain = () => {


    return (
        <Box>
            <Routes>
                <Route path="/list" element={
                    <RecoilRoot key='customerbase.search'>
                        <CustomerBaseList/>
                    </RecoilRoot>
                }/>
                <Route path="/view/:id" element={
                    <RecoilRoot key='customerbase.view'>
                        <ViewCustomerBase/>
                    </RecoilRoot>
                }
                />
                <Route path={"/" +  CBCreationPathName.PERSON_CREATE} element={
                    <RecoilRoot key='customerbase.person.create'>
                        <ViewCustomerBase creationOf="person"/>
                    </RecoilRoot>
                }
                />
                <Route path={"/" +  CBCreationPathName.ORGANIZATION_CREATE} element={
                    <RecoilRoot key='customerbase.organization.create'>
                        <ViewCustomerBase creationOf="organization"/>
                    </RecoilRoot>
                }
                />
                <Route path="*" element={<PageNotFound/>}/>
            </Routes>
        </Box>
    );
}

export default CustomerBaseMain;
